module.exports = __webpack_public_path__ + "static/flags/TC-70f573dff95bda57070556c760caad6b.gif";